import { DividerComponent, PaperComponent } from "@/components";
import { WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import React from "react";

const InsuranceDetailsCard = ({
  nomineeName,
  relationship,
  mobileNumber,
  dob,
}) => {
  function DetailField(header, value) {
    return (
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
      >
        <Typography color={WEB_COLORS.textFadeColor}>{header}</Typography>
        <Typography fontWeight={"bold"}>{value}</Typography>
      </Stack>
    );
  }
  return (
    <PaperComponent>
      <Stack gap={2}>
        <Typography variant="h5"> Insurance Details</Typography>
        <DividerComponent orientation="horizontal" />
        {DetailField("Nominee Name", nomineeName)}
        {DetailField("Relationship", relationship)}
        {DetailField("Mobile Number", mobileNumber)}
        {DetailField("DOB", dob)}
      </Stack>
    </PaperComponent>
  );
};

export default InsuranceDetailsCard;
